/* BERGAMORA header interactions — desktop dropdowns, off-canvas mobile accordions, and cart sync */
(function () {
  'use strict';

  var controllerVersion = '2026-10-02-side-drawer-v4';
  if (window.berHeaderControllerVersion === controllerVersion) return;
  window.berHeaderControllerVersion = controllerVersion;
  window.berHeaderControllerLoaded = true;

  var cartRefreshPromise = null;
  var tabletQuery = window.matchMedia('(max-width: 1099px)');

  function setHeaderCartCount(itemCount) {
    var count = Math.max(0, parseInt(itemCount, 10) || 0);

    document.querySelectorAll('[data-ber-cart-label]').forEach(function (label) {
      label.textContent = 'Cart (' + count + ')';
    });

    document.querySelectorAll('[data-ber-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    });

    document.querySelectorAll('[data-ber-cart-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
    });
  }

  function cartJsonUrl() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function refreshHeaderCartCount() {
    if (cartRefreshPromise) return cartRefreshPromise;

    cartRefreshPromise = fetch(cartJsonUrl(), {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart count');
        return response.json();
      })
      .then(function (cart) {
        setHeaderCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        cartRefreshPromise = null;
      });

    return cartRefreshPromise;
  }

  function openCartDrawer(trigger, event) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;
    if (event) event.preventDefault();
    cartDrawer.open(trigger);
    return true;
  }

  function closeDesktopDropdown(item) {
    if (!item) return;
    item.classList.remove('ber-hdr__nav-item--open');
    var trigger = item.querySelector(':scope > .ber-hdr__nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeDropdowns(exceptItem) {
    document.querySelectorAll('.ber-hdr__nav-item--has-children').forEach(function (item) {
      if (item !== exceptItem) closeDesktopDropdown(item);
    });
  }

  function mobileItemParts(item) {
    var row = item && item.querySelector(':scope > .ber-hdr__mobile-nav-row');
    var link = row && row.querySelector(':scope > a');
    var toggle = row && row.querySelector(':scope > .ber-hdr__mobile-submenu-toggle');
    var submenu = item && item.querySelector(':scope > .ber-hdr__mobile-submenu');

    return {
      row: row,
      link: link,
      toggle: toggle,
      submenu: submenu
    };
  }

  function setMobileItemExpanded(item, expanded) {
    var parts = mobileItemParts(item);
    if (!parts.submenu) return false;

    item.classList.toggle('ber-hdr__mobile-nav-item--open', expanded);
    parts.submenu.setAttribute('aria-hidden', expanded ? 'false' : 'true');

    if (parts.toggle) parts.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (parts.link) parts.link.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    return true;
  }

  function closeMobileItem(item) {
    if (!item) return;
    setMobileItemExpanded(item, false);

    item.querySelectorAll('[data-ber-mobile-item].ber-hdr__mobile-nav-item--open').forEach(function (nestedItem) {
      setMobileItemExpanded(nestedItem, false);
    });
  }

  function syncBodyMenuState() {
    var menuIsOpen = Boolean(document.querySelector('.ber-hdr__mobile-nav--open'));
    document.body.classList.toggle('ber-hdr-menu-open', menuIsOpen);
  }

  function setMobileBackdropState(header, expanded) {
    if (!header) return;
    var backdrop = header.querySelector('.ber-hdr__mobile-backdrop');
    if (!backdrop) return;

    backdrop.classList.toggle('ber-hdr__mobile-backdrop--open', expanded);
    backdrop.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  }

  function ensureMobileBackdrop(header) {
    if (!header) return null;

    var backdrop = header.querySelector('.ber-hdr__mobile-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('button');
      backdrop.type = 'button';
      backdrop.className = 'ber-hdr__mobile-backdrop';
      backdrop.setAttribute('aria-label', 'Close menu');
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.tabIndex = -1;
      header.appendChild(backdrop);
    }

    if (backdrop.dataset.berBackdropReady !== controllerVersion) {
      backdrop.dataset.berBackdropReady = controllerVersion;
      backdrop.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeMobileNavigation(header, true);
      });
    }

    return backdrop;
  }

  function closeMobileNavigation(header, restoreFocus) {
    if (!header) return;
    var mobileNav = header.querySelector('.ber-hdr__mobile-nav');
    var hamburger = header.querySelector('.ber-hdr__hamburger');
    var wasOpen = mobileNav && mobileNav.classList.contains('ber-hdr__mobile-nav--open');

    if (mobileNav) {
      mobileNav.classList.remove('ber-hdr__mobile-nav--open');
      mobileNav.setAttribute('aria-hidden', 'true');
      mobileNav.querySelectorAll('[data-ber-mobile-item]').forEach(closeMobileItem);
    }

    setMobileBackdropState(header, false);

    if (hamburger) {
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.setAttribute('aria-label', 'Open menu');
      if (restoreFocus && wasOpen) {
        try {
          hamburger.focus({ preventScroll: true });
        } catch (error) {
          hamburger.focus();
        }
      }
    }

    syncBodyMenuState();
  }

  function closeAllMobileNavigation() {
    document.querySelectorAll('.ber-hdr').forEach(function (header) {
      closeMobileNavigation(header, false);
    });
  }

  function openMobileNavigation(header) {
    var mobileNav = header.querySelector('.ber-hdr__mobile-nav');
    var hamburger = header.querySelector('.ber-hdr__hamburger');
    if (!mobileNav || !hamburger) return;

    closeDropdowns();
    closeAllMobileNavigation();
    ensureMobileBackdrop(header);

    mobileNav.classList.add('ber-hdr__mobile-nav--open');
    mobileNav.setAttribute('aria-hidden', 'false');
    setMobileBackdropState(header, true);
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Close menu');
    syncBodyMenuState();
  }

  function toggleMobileItem(item) {
    if (!item) return false;

    var parts = mobileItemParts(item);
    if (!parts.submenu) return false;

    var isOpen = item.classList.contains('ber-hdr__mobile-nav-item--open');
    var parentList = item.parentElement;

    if (!isOpen && parentList) {
      Array.prototype.forEach.call(parentList.children, function (sibling) {
        if (sibling !== item && sibling.matches('[data-ber-mobile-item]')) closeMobileItem(sibling);
      });
    }

    if (isOpen) closeMobileItem(item);
    else setMobileItemExpanded(item, true);

    return true;
  }

  function stopRowActivation(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  function initMobileNavigation(header, mobileNav) {
    mobileNav.querySelectorAll('[data-ber-mobile-item]').forEach(function (item) {
      var parts = mobileItemParts(item);
      if (!parts.row || !parts.submenu) return;
      if (parts.row.dataset.berFullRowReady === controllerVersion) return;
      parts.row.dataset.berFullRowReady = controllerVersion;

      parts.row.classList.add('ber-hdr__mobile-nav-row--interactive');
      parts.submenu.setAttribute('aria-hidden', 'true');

      if (parts.link) {
        parts.link.setAttribute('aria-haspopup', 'true');
        parts.link.setAttribute('aria-expanded', 'false');
      }

      /* Every tap on a parent row is an accordion action. The label, empty
         row space, and chevron all open on the first tap and close on the
         second tap. Capture phase prevents the parent anchor from navigating. */
      parts.row.addEventListener(
        'click',
        function (event) {
          var target = event.target;
          if (!(target instanceof Element)) return;

          stopRowActivation(event);
          toggleMobileItem(item);
        },
        true
      );

      parts.row.addEventListener(
        'keydown',
        function (event) {
          var target = event.target;
          if (!(target instanceof Element)) return;
          if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

          stopRowActivation(event);
          toggleMobileItem(item);
        },
        true
      );
    });

    /* Links without a submenu still navigate normally and close the drawer. */
    mobileNav.querySelectorAll('a').forEach(function (link) {
      if (link.dataset.berLeafReady === controllerVersion) return;
      link.dataset.berLeafReady = controllerVersion;
      link.addEventListener('click', function () {
        var item = link.closest('[data-ber-mobile-item]');
        var parts = mobileItemParts(item);
        if (!parts.submenu) closeMobileNavigation(header, false);
      });
    });
  }

  function initBerHeader(header) {
    if (header.dataset.berHeaderReady === controllerVersion) return;
    header.dataset.berHeaderReady = controllerVersion;

    var hamburger = header.querySelector('.ber-hdr__hamburger');
    var mobileNav = header.querySelector('.ber-hdr__mobile-nav');

    header.querySelectorAll('[data-ber-cart-trigger]').forEach(function (trigger) {
      if (trigger.dataset.berCartReady === controllerVersion) return;
      trigger.dataset.berCartReady = controllerVersion;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        openCartDrawer(trigger, event);
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.code !== 'Space') return;
        openCartDrawer(trigger, event);
      });
    });

    if (hamburger && mobileNav) {
      ensureMobileBackdrop(header);

      if (hamburger.dataset.berMenuReady !== controllerVersion) {
        hamburger.dataset.berMenuReady = controllerVersion;
        hamburger.addEventListener('click', function () {
          var isOpen = mobileNav.classList.contains('ber-hdr__mobile-nav--open');
          if (isOpen) closeMobileNavigation(header, false);
          else openMobileNavigation(header);
        });
      }

      initMobileNavigation(header, mobileNav);
    }

    header.querySelectorAll('.ber-hdr__nav-item--has-children').forEach(function (item) {
      if (item.dataset.berDesktopReady === controllerVersion) return;
      item.dataset.berDesktopReady = controllerVersion;
      var trigger = item.querySelector(':scope > .ber-hdr__nav-link');
      if (!trigger) return;

      trigger.addEventListener('click', function (event) {
        if (!window.matchMedia('(hover: none), (pointer: coarse)').matches || tabletQuery.matches) return;

        var isOpen = item.classList.contains('ber-hdr__nav-item--open');
        if (!isOpen) {
          event.preventDefault();
          closeDropdowns(item);
          item.classList.add('ber-hdr__nav-item--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });

      item.addEventListener('mouseenter', function () {
        trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', function () {
        if (!item.classList.contains('ber-hdr__nav-item--open') && !item.contains(document.activeElement)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      item.addEventListener('focusin', function () {
        closeDropdowns(item);
        item.classList.add('ber-hdr__nav-item--open');
        trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('focusout', function () {
        window.requestAnimationFrame(function () {
          if (!item.contains(document.activeElement)) closeDesktopDropdown(item);
        });
      });
    });

    if (header.dataset.berEscapeReady !== controllerVersion) {
      header.dataset.berEscapeReady = controllerVersion;
      header.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;

        var openItem = header.querySelector('.ber-hdr__nav-item--open');
        if (openItem) {
          event.preventDefault();
          var trigger = openItem.querySelector(':scope > .ber-hdr__nav-link');
          if (trigger) {
            try {
              trigger.focus({ preventScroll: true });
            } catch (error) {
              trigger.focus();
            }
          }
          closeDesktopDropdown(openItem);
        }

        closeMobileNavigation(header, true);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ber-hdr').forEach(initBerHeader);
  }

  function registerGlobalInteractions() {
    if (window.berHeaderGlobalVersion === controllerVersion) return;
    window.berHeaderGlobalVersion = controllerVersion;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element) || !target.closest('.ber-hdr')) {
        closeDropdowns();
        closeAllMobileNavigation();
      }
    });

    var onBreakpointChange = function () {
      closeDropdowns();
      closeAllMobileNavigation();
    };

    if (typeof tabletQuery.addEventListener === 'function') tabletQuery.addEventListener('change', onBreakpointChange);
    else if (typeof tabletQuery.addListener === 'function') tabletQuery.addListener(onBreakpointChange);
  }

  function registerCartSync() {
    if (window.berHeaderCartSyncVersion === controllerVersion) return;
    window.berHeaderCartSyncVersion = controllerVersion;

    document.addEventListener('ber:cart:updated', refreshHeaderCartCount);
    window.addEventListener('pageshow', refreshHeaderCartCount);

    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var cartData = event && event.cartData;
        if (cartData && typeof cartData.item_count === 'number') {
          setHeaderCartCount(cartData.item_count);
          return;
        }
        refreshHeaderCartCount();
      });
    }
  }

  function start() {
    initAll(document);
    registerGlobalInteractions();
    registerCartSync();
    syncBodyMenuState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    closeAllMobileNavigation();
  });
})();
